import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import { NeuButton, NeuInput, NeuSelect } from "../../components/neu/Neu";

export const EMPTY_LINE = { description: "", quantity: "1", uom: "EA", unit_price: "0.00",
                            hs_code: "", is_service: false, tax_code_key: "ae_standard" };

const TAX_KEYS = ["ae_standard", "ae_zero_export", "ae_exempt", "ae_out_of_scope", "ae_reverse_charge"];

// سطر واحد في محرّر العرض.
export const LineEditor = ({ line, index, onChange, onRemove }) => {
  const { t } = useTranslation();
  const set = (key) => (e) => onChange(index, { ...line, [key]: e.target.value });

  return (
    <div className="grid gap-2 rounded-2xl p-3 shadow-neu-in sm:grid-cols-[2fr_repeat(4,minmax(0,1fr))_auto]"
         data-testid={`line-editor-${index}`}>
      <NeuInput data-testid={`line-desc-${index}`} placeholder={t("sales.description")}
                value={line.description} onChange={set("description")} />
      <NeuInput data-testid={`line-qty-${index}`} placeholder={t("sales.qty")} dir="ltr"
                value={line.quantity} onChange={set("quantity")} />
      <NeuInput data-testid={`line-price-${index}`} placeholder={t("sales.unitPrice")} dir="ltr"
                value={line.unit_price} onChange={set("unit_price")} />
      <NeuSelect data-testid={`line-tax-${index}`} value={line.tax_code_key} onChange={set("tax_code_key")}>
        {TAX_KEYS.map((key) => (
          <option key={key} value={key}>{t(`sales.taxKeys.${key}`)}</option>
        ))}
      </NeuSelect>
      <NeuSelect data-testid={`line-kind-${index}`} value={line.is_service ? "service" : "goods"}
                 onChange={(e) => onChange(index, { ...line, is_service: e.target.value === "service" })}>
        <option value="goods">{t("sales.goods")}</option>
        <option value="service">{t("sales.service")}</option>
      </NeuSelect>
      <NeuButton className="px-3 py-2 text-xs" data-testid={`line-remove-${index}`} onClick={() => onRemove(index)}>
        <Trash2 className="h-3.5 w-3.5" />
      </NeuButton>
      {!line.is_service ? (
        <NeuInput className="sm:col-span-6" data-testid={`line-hs-${index}`} dir="ltr"
                  placeholder={t("sales.hsCode")} value={line.hs_code} onChange={set("hs_code")} />
      ) : null}
    </div>
  );
};
